import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Mentor, MentorStatus } from '../../api/mentors';
import { useMentorsContext } from '../../contexts/mentors-context';
import { useResourceBundles } from '../../contexts/resource-bundles-context';
import { UserContext } from '../../contexts/user-context';
import { getRoutePath, Pages } from '../../router/constants';
import TableActions from '../common/table-actions';

function MentorsRowActions({
  mentor,
  variant,
}: {
  mentor: Mentor;
  variant?: 'table' | 'list';
}) {
  const history = useHistory();
  const location = useLocation();
  const { hasAccessToAction } = useContext(UserContext);
  const {
    setProfileUpdateTargetMentorId,
    setAssignTargetMentor,
    setInviteTargetMentorId,
    setArchiveTargetMentors,
  } = useMentorsContext();
  const { rb } = useResourceBundles();

  const prevPath = `${location.pathname}${location.search}`;

  return (
    <TableActions
      variant={variant}
      actions={[
        {
          key: 'row-action-note',
          onClick: () =>
            history.push({
              pathname: getRoutePath(Pages.MENTOR_NOTES, {
                mentorId: mentor.id,
              }),
              state: { prevPath },
            }),
          icon: <AddIcon fontSize='small' color='inherit' />,
          label: 'Note',
          hidden: !hasAccessToAction('mentor.notes.view'),
        },
        {
          key: 'row-action-mentor-card',
          onClick: () =>
            window.open(
              getRoutePath(Pages.MENTOR_CARD, { mentorId: mentor.id }),
              '_blank',
            ),
          label: `${rb('mentor-u')} Card`,
          hidden: !hasAccessToAction('mentor.details.view'),
        },
        {
          key: 'row-action-enrich',
          onClick: () =>
            history.push({
              pathname: getRoutePath(Pages.MENTOR_DETAILS, {
                mentorId: mentor.id,
              }),
              state: { prevPath, openEnrichModal: true },
            }),
          label: 'Enrich Profile',
          hidden: !hasAccessToAction('mentor.details.update'),
        },
        {
          key: 'row-action-request-profile-update',
          onClick: () => setProfileUpdateTargetMentorId(mentor.id),
          label: 'Request Profile Update',
          hidden: !hasAccessToAction('mentor.details.update'),
        },
        {
          key: 'row-action-assign-mentor',
          onClick: () => setAssignTargetMentor(mentor),
          label: 'Assign',
          hidden: !hasAccessToAction('mentor.details.update'),
        },
        {
          key: 'row-action-invite-mentor',
          onClick: () => setInviteTargetMentorId(mentor.id),
          label: 'Send Invite',
          hidden: !hasAccessToAction('userManagement.mentor'),
        },
        {
          key: 'row-action-archive',
          onClick: () => setArchiveTargetMentors([mentor]),
          label: 'Archive',
          hidden:
            !hasAccessToAction('mentor.details.update') ||
            mentor.status === MentorStatus.ARCHIVED,
        },
      ]}
    />
  );
}

export default MentorsRowActions;
